/** Filter already-public directory cards without changing group tabs or redemption rules. */
(() => {
    const directory = document.getElementById('perks-directory');
    const search = directory?.querySelector('#perks-search');
    if (!search) return;

    const normalise = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
    const tabCounts = new Map(Array.from(directory.querySelectorAll('[data-tab]'), tab => [
        `tab-${tab.dataset.tab}`, tab.querySelector('[data-tab-count]'),
    ]));
    const groups = Array.from(directory.querySelectorAll('[data-perks-search-group]'), group => ({
        empty: group.querySelector('[data-perks-search-empty]'),
        count: tabCounts.get(group.closest('.tab-content')?.id),
        cards: Array.from(group.querySelectorAll('[data-perk-search]'), card => ({
            element: card,
            text: normalise(card.dataset.perkSearch || ''),
        })),
    }));
    const filter = () => {
        const terms = normalise(search.value).trim().split(/\s+/).filter(Boolean);
        groups.forEach(group => {
            let matches = 0;
            group.cards.forEach(card => {
                const visible = terms.every(term => card.text.includes(term));
                card.element.classList.toggle('hidden', !visible);
                if (visible) matches += 1;
            });
            group.empty?.classList.toggle('hidden', matches > 0);
            if (group.count) group.count.textContent = String(matches);
        });
    };
    search.addEventListener('input', filter);
    // Native search clear buttons and restored browser form values also apply immediately.
    search.addEventListener('search', filter);
    window.addEventListener('pageshow', filter);
    directory.querySelector('[data-perks-search-control]')?.classList.remove('hidden');
    filter();
})();
